export default __webpack_public_path__ + "static/media/5.4b9a9fe2.jpg";